// Shared table styles to ensure consistency between Stock Table and custom tables
export const TABLE_STYLES = {
  // Table container styles
  tableContainer: "bg-surface-light dark:bg-background-card border border-border-light dark:border-border-color rounded-lg shadow-lg",
  tableWrapper: "w-full overflow-x-auto overflow-y-auto max-h-[80vh]",
  table: "min-w-full font-mono",
  
  // Header styles
  statisticsHeader: "py-1 px-4 text-left text-gray-600 dark:text-text-secondary text-xs font-semibold uppercase tracking-wider bg-gray-50 dark:bg-background-card",
  columnHeader: "py-1 px-6 text-left text-xs font-semibold uppercase tracking-wider h-16 bg-gray-50 dark:bg-background-card",
  
  // Data row styles
  statisticsLabel: "px-4 whitespace-nowrap text-gray-900 dark:text-text-primary font-medium bg-surface-light dark:bg-background-card",
  dataCell: "px-6 whitespace-nowrap font-semibold h-16 transition-all duration-300",
  
  // Row background styles (Stock Table doesn't use alternating colors, it uses divide-y)
  tbody: "divide-y divide-gray-200 dark:divide-border-color",
  
  // Border styles
  rowBorder: "border-b border-gray-200 dark:border-border-color",
  
  // Loading and error styles
  loadingCell: "animate-pulse bg-gray-200 dark:bg-border-color h-4 w-16 rounded",
  errorText: "text-gray-600 dark:text-text-secondary",
  
  // Status bar styles
  statusBar: "px-4 py-2 border-t border-gray-200 dark:border-border-color bg-gray-50 dark:bg-black/10 flex justify-between items-center text-xs text-gray-600 dark:text-text-secondary",
  refreshButton: "text-highlight-gold hover:text-yellow-400 transition-colors",
  
  // Z-index values
  stickyHeader: 50,
  stickyStatistics: 40,
  stickyData: 30,
  
  // Padding values (matching Stock Table exactly)
  dataRowPadding: {
    paddingTop: '0px',
    paddingBottom: '0px'
  }
} as const;
